import { render, staticRenderFns } from "./FormProductSaleCommission.vue?vue&type=template&id=5751544c&scoped=true&"
import script from "./FormProductSaleCommission.vue?vue&type=script&lang=js&"
export * from "./FormProductSaleCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5751544c",
  null
  
)

export default component.exports